// @flow
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import React from "react";
import type { GameFilterTypes } from "../../common/types";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import grey from "@material-ui/core/colors/grey";
import useMediaQuery from "@material-ui/core/useMediaQuery";

type Props = {
  gameFilter: GameFilterTypes,
  setGameFilter: Function,
};

const useStyles = makeStyles(() =>
  createStyles({
    tabs: {
      borderRadius: 9,
      overflow: "hidden",
      padding: 2,
      minHeight: 32,
      backgroundColor: "var(--bg)",
    },
    tabRoot: {
      minHeight: 32,
      padding: 0,
      color: "var(--color)",
      touchAction: "manipulation",
    },
    flexContainer: {
      zIndex: 2,
      position: "relative",
    },
    indicator: {
      backgroundColor: "var(--indicator-bg)",
      borderRadius: 7,
      top: 0,
      bottom: 0,
      height: "auto",
      minWidth: "50%",
      zIndex: 1,
    },
    textColorInherit: {
      opacity: 1,
    },
  })
);

function ScheduleHeaderTabs({ gameFilter, setGameFilter }: Props) {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const classes = useStyles();

  const getCustomColors = (prefersDarkMode) => ({
    "--indicator-bg": prefersDarkMode ? grey[800] : "#fff",
    "--bg": prefersDarkMode ? grey[900] : grey[300],
    "--color": prefersDarkMode ? "white" : "black",
  });

  const colors = React.useMemo(() => getCustomColors(prefersDarkMode), [
    prefersDarkMode,
  ]);

  const TABS = [
    {
      id: "ALL_GAMES",
      label: "Alle",
    },
    {
      id: "HOMEGAMES",
      label: "Heim",
    },
  ];

  return (
    <Tabs
      value={TABS.findIndex((tab) => tab.id === gameFilter)}
      onChange={(event, newValue) => {
        setGameFilter(TABS[newValue].id);
      }}
      variant="fullWidth"
      classes={{
        root: classes.tabs,
        indicator: classes.indicator,
        flexContainer: classes.flexContainer,
      }}
      style={colors}
    >
      {TABS.map((tab) => (
        <Tab
          classes={{
            root: classes.tabRoot,
            textColorInherit: classes.textColorInherit,
          }}
          label={tab.label}
          key={tab.id}
        />
      ))}
    </Tabs>
  );
}

export default ScheduleHeaderTabs;
